// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"main": 0,
	"vendor": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(default\-webpack_sharing_consume_default_(a(ngular_(c(dk_(overlay_angular_cdk_overlay|portal_angular_cdk_portal|scrolling_angular_cdk_scrolling)|o(mmon_(angular_common|http_angular_common_http)|re_(angular_core|rxjs\-interop_angular_core_rxjs\-interop)))|(platform\-browser_angular_platform\-brows|router_angular_rout)er|forms_angular_forms)|uth0_a(uth0\-(angular_auth0_auth0\-angular|spa\-js_auth0_auth0\-spa\-js)|ngular\-jwt_auth0_angular\-jwt))|rxjs_(operators_rxjs_operator|rxj)s|snelstart_(u(i(\-(d(etails_snelstart_ui\-details|ialog_snelstart_ui\-dialog|rag\-and\-drop_snelstart_ui\-drag\-and\-drop\-7328de|ropdown_snelstart_ui\-dropdown)|t(o(oltip(\-trigger_snelstart_ui\-tooltip\-trigger|_snelstart_ui\-tooltip)|ast_snelstart_ui\-toast)|ag_snelstart_ui\-tag)|(button_snelstart_ui\-butt|icon_snelstart_ui\-ic)on|action\-sheet_snelstart_ui\-action\-sheet|alert_snelstart_ui\-alert|badge_snelstart_ui\-badge|context\-menu_snelstart_ui\-context\-menu|filter\-container_snelstart_ui\-filter\-container|form\-controls_snelstart_ui\-form\-controls|loading_snelstart_ui\-loading|panel_snelstart_ui\-panel|search\-control_snelstart_ui\-search\-control)|_snelstart_ui)|til(\-(address_snelstart_util\-address\-webpack\-ca206b|events_snelstart_util\-events|feature\-flag_snelstart_util\-feature\-flag|logging_snelstart_util\-logging|route\-state_snelstart_util\-route\-state|search_snelstart_util\-search|state\-store_snelstart_util\-state\-store)|_snelstart_util))|domain\-logic_snelstart_domain\-logic|models\-environment_snelstart_models\-environment)|(bufbuild_protobuf_wire_bufbuild_protobuf_wi|ngrx_store_ngrx_sto)re|bootstrap_bootstrap)|vendor)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkbank_web_shell"] = self["webpackChunkbank_web_shell"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));